var map = {
	"./10_nuts.png": 2467,
	"./1drink_12beer.png": 2468,
	"./1serving_8ounces.png": 2469,
	"./1serving_8ounces2.png": 2470,
	"./1serving_8ounces3.png": 2471,
	"./1serving_8ounces4.png": 2472,
	"./1serving_8ounces5.png": 2473,
	"./8ounces_1glass.png": 2474,
	"./can_1.png": 2475,
	"./can_2.png": 2476,
	"./can_3.png": 2477,
	"./cup.png": 2478,
	"./dried_serving_1/4cup.png": 2479,
	"./dried_serving_1:4cup.png": 2480,
	"./fresh_serving_1cup.png": 2481,
	"./glass_1.png": 2482,
	"./glass_2.png": 2483,
	"./golfball.png": 2484,
	"./halfthumb.png": 2485,
	"./hand_1.png": 2486,
	"./hand_2.png": 2487,
	"./hand_3.png": 2488,
	"./hand_4.png": 2489,
	"./hand_5.png": 2490,
	"./how.png": 859,
	"./serving_1/2cup.png": 2491,
	"./serving_1:2cup.png": 2492,
	"./serving_1tbsp.png": 2493,
	"./serving_3/4ounces.png": 2494,
	"./serving_3:4ounces.png": 2495,
	"./thumbx2.png": 2496,
	"./usda.png": 2497,
	"./vegetables_1cup.png": 2498,
	"./what.png": 857,
	"./wholethumb.png": 2499,
	"./why.png": 858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2466;